import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Alert, Button, Table } from 'reactstrap';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as Sites from '../store/Sites';
import * as Patients from '../store/Patients';
import * as Records from '../store/Records';
import * as sortfilter from '../data/SortFilter';

const SelectionsType = {
    sites: "sites",
    patients: "patients",
}


export default function Selections(props)
{
	const [studyId, setStudyId] = useState( null ); 
	const [whichSelectable, setWhichSelectable] = useState( SelectionsType.sites ); 
	const [isShowingFilter, setIsShowingFilter] = useState( false );
	const [currentFilters, setCurrentFilters] = useState( {} );
	const [currentSortDirection, setCurrentSortDirection] = useState( {} );
	const [currentSortingColumn, setCurrentSortingColumn] = useState( '' );


	// redux variables
	const dispatch = useDispatch();
	const accountsState = useSelector(state => state.accounts);
	const sitesState = useSelector(state => state.sites);
	const patientsState = useSelector(state => state.patients);
	const recordsState = useSelector(state => state.records);

	// redux dispatchers
	const sitesDispatch = bindActionCreators(Sites.actionCreators, dispatch);
	const patientsDispatch = bindActionCreators(Patients.actionCreators, dispatch);




	/* occurs after each render */
	useEffect(() => {

		return () => {
			cleanupBeforeReRender();
		};
	});


	if ( ! Accounts.authenticatedAdministrator(accountsState) ) {
		return (
			<NotAuthenticated />
		);
	}


	/* check if this is a new study to know if we should render stuff afresh or not */
	if ( studyId !== props.studyId ) {
		setStudyId( props.studyId );
		sitesState.all = null;
		recordsState.patientFilter = null;
	}


	if ( studyId && (whichSelectable === SelectionsType.sites) && accountsState.authenticated && ! sitesState.fetching && (sitesState.all === null) ) {
		sitesState.all = null;
		sitesDispatch.getAllByStudy(studyId);
	}





	const toggleFilter = () => {
		if ( isShowingFilter ) {
			setCurrentFilters( {} );
		}
		setIsShowingFilter( ! isShowingFilter );
	}

	const ColumnHeader = (props) =>
	{
		const onSortChange = (currentColumn) => {
			let nextSort = 'default';

			switch ( currentSortDirection[currentColumn] ) {
				case "down": nextSort = 'default'; break;
				case "up"  : nextSort = 'down'; break;
				default    : nextSort = 'up'; break;
			}

			let newCurrentSortDirection = {};
			newCurrentSortDirection[currentColumn] = nextSort;

			setCurrentSortDirection( newCurrentSortDirection );
			setCurrentSortingColumn( currentColumn );
		};

		const onFilterChange = (e) => {
			setCurrentFilters( {...currentFilters, [e.target.name]: e.target.value } );
		};

		sortfilter.filterAssociation[props.recordKey] = props.label;
		let val = currentFilters[props.label];
		if ( val === undefined ) {
			val = '';
		}
		return <sortfilter.ColHeader value={val} onChange={(e) => onFilterChange()} sortDir={currentSortDirection} onSortChange={onSortChange} showFilter={isShowingFilter} label={props.label} recordKey={props.recordKey} />
	};




	function handlePatientSelected(patientCode,selectTab)
	{
		setWhichSelectable(SelectionsType.sites);
		sitesState.all = null;
		patientsState.all = null;
		selectTab(patientCode);
	}


	function handleSiteSelected(id)
	{
		setWhichSelectable(SelectionsType.patients);
		sitesState.all = null;
		patientsState.all = null;
		patientsDispatch.getAllByStudyAndSite(studyId,id);
	}


	function percentComplianceFor(id,serviceType)
	{
		let compliancy = 0;
		let rowsname = '';

		switch ( serviceType ) {
			case Records.recordServiceTypes.event:
				rowsname = 'eventRows';
				break;
			case Records.recordServiceTypes.holter:
				rowsname = 'holterRows';
				break;
			case Records.recordServiceTypes.twelveLead:
				rowsname = 'twelveLeadRows';
				break;
			case 'overall':
			default:
				rowsname = 'overall';
				break;
		}

		if ( recordsState.allCompliancyRows && recordsState.allCompliancyRows[rowsname]  ) {
			const rec = recordsState.allCompliancyRows[rowsname].find( r => r.subjectsId === id );
			if ( rec ) {
				compliancy = rec.compliance;
			}
		}

		return Math.min(compliancy,101);
	}



	let theRendering = <Alert color="primary" > Loading... </Alert>;
	var rowNum = 1;

	if ( patientsState.all && recordsState.allCompliancyRows ) {

		if ( patientsState.all.length === 0 ) {
			setTimeout(() => { 
				setWhichSelectable(SelectionsType.sites);
				sitesState.all = null;
				patientsState.all = null;
			}, 2000);
			theRendering = <Alert className="animated fadeOut center"> <p> No Patients found at this site.  </p> </Alert>;
		} else {
			rowNum = 1;

			let pList = patientsState.all;
			pList = sortfilter.filterData( pList, currentFilters );

			pList = [...pList].map( (patient,idx) => {
				return ({ ...patient,
					complianceEvent: percentComplianceFor(patient.code,Records.recordServiceTypes.event),
					complianceHolter: percentComplianceFor(patient.code,Records.recordServiceTypes.holter),
					complianceTwelveLead: percentComplianceFor(patient.code,Records.recordServiceTypes.twelveLead),
					complianceOverall: percentComplianceFor(patient.code,'overall'),
				});
            });

			const patientList = [...pList].sort( sortfilter.sortingDetails(currentSortingColumn,currentSortDirection).fn ).map(patient => {
				return (
					<tr key={patient.id} onClick={() => handlePatientSelected(patient.code,props.selectTab)}>
						<th scope="row">{rowNum++}</th>
						<td> {patient.code} </td>
						<td align="center"> {patient.complianceEvent > 100 ? '100+' : patient.complianceEvent} % </td>
						<td align="center"> {patient.complianceHolter > 100 ? '100+' : patient.complianceHolter} % </td>
						<td align="center"> {patient.complianceTwelveLead > 100 ? '100+' : patient.complianceTwelveLead} % </td>
						<td align="center"> {patient.complianceOverall > 100 ? '100+' : patient.complianceOverall} % </td>
						<td> {patient.enrollDate} </td>
						<td> {patient.procedureDate} </td>
					</tr>
				);
			});

			theRendering = <div>
				<h3> Select Patient... </h3>
				<Button className="button filter_button" id="btnFilter" title="Filter" onClick={toggleFilter}> Filter </Button>
				<br />
				<Table striped hover>
					<thead>
						<tr>
							<th>#</th>
							<ColumnHeader label="Code" recordKey="code" />
							<ColumnHeader label="Event Compliance" recordKey="complianceEvent" />
							<ColumnHeader label="Holter Compliance" recordKey="complianceHolter" />
							<ColumnHeader label="12-Lead Compliance" recordKey="complianceTwelveLead" />
							<ColumnHeader label="Overall Compliance" recordKey="complianceTwelveLead" />
							<ColumnHeader label="Enroll Date" recordKey="enrollDate" />
							<ColumnHeader label="Procedure Date" recordKey="procedureDate" />
						</tr>
					</thead>
					<tbody>
						{patientList}
					</tbody>
				</Table>
			</div>;
		}
	}


	if ( sitesState.all ) {
		rowNum = 1;

		let sList = sitesState.all;
		sList = sortfilter.filterData( sList, currentFilters );

		const siteList = [...sList].sort( sortfilter.sortingDetails(currentSortingColumn,currentSortDirection).fn ).map(site => {
			return (
				<tr key={site.id} onClick={() => handleSiteSelected(site.id)}>
					<th scope="row">{rowNum++}</th>
					<td>{site.name}</td>
					<td>{site.code}</td>
				</tr>
			);
		});

		theRendering = <div>
			<h3> Select Site... </h3>
			<Button className="button filter_button" id="btnFilter" title="Filter" onClick={toggleFilter}> Filter </Button>
			<br />
			<Table striped hover>
				<thead>
					<tr>
						<th>#</th>
						<ColumnHeader label="Name" recordKey="name" />
						<ColumnHeader label="Code" recordKey="code" />
					</tr>
				</thead>
				<tbody>
					{siteList}
				</tbody>
			</Table>
		</div>;
	}

	return theRendering;
}


function cleanupBeforeReRender()
{
}





// WEBPACK FOOTER //
// ./src/components/Selections.js